import NewspaperAdvancedSettingForm from './NewspaperAdvancedSettingForm'
export default NewspaperAdvancedSettingForm
